import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MarkAsReadOrUnread from '../MarkAsReadOrUnread/MarkAsReadOrUnread';
import { Icon } from 'components';
import styles from './NotificationMessage.scss';

const NotificationMessage = ({
  notification,
  close,
  action,
  notificationData,
  staticTexts,
  onClickMarkAsRead,
}) => {
  const handleAction = () => {
    action(notification.data.question.id, notification.data.requestId, notification.id);
    close();
  };

  return (
    <div
      className={classnames(styles.notificationsItem, {[styles.unseen]: !notification.seen})}
      onClick={handleAction}
      data-testid={`alerts-popOver__alert-${notification.id}`}
    >
      <div className={styles.notificationHeader}>
        <div className={styles.notificationTitle}>{notification.data.title}</div>
        <div className={styles.date}>{notification.createdAt}</div>
      </div>
      <div className={styles.replyMessage}>
        <Icon
            name={`ion-md-${ notification.type === 'requestCommentCreated' ? 'chatboxes' : 'at'}`}
            className={styles.messageIcon}
        />
        <b>{notification.data.author}</b>&nbsp;
        { notification.type === 'requestCommentCreated' ?
            notificationData.commentNotification.replyStaticText :
            notificationData.commentNotification.taggedStaticText
        }
      </div>
      <MarkAsReadOrUnread
        markAsReadStyle={styles.markAsRead}
        notification={notification}
        staticTexts={staticTexts}
        onClickMarkAsRead={onClickMarkAsRead}
      />
      <div className={styles.messageQuestion}>{notification.data.question.title}</div>
    </div>
  );
};

NotificationMessage.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.string,
    type: PropTypes.string,
    seen: PropTypes.bool,
    data: PropTypes.object,
  }).isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  notificationData: PropTypes.shape({
    commentNotification: PropTypes.shape({
      replyStaticText: PropTypes.string,
      taggedStaticText: PropTypes.string
    })
  }).isRequired,
  staticTexts: PropTypes.shape({
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
  }).isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
};

export default NotificationMessage;
